import React from 'react';
import './HomePopup.scss';

const HomePopup = ({ isOpen, onClose, content }) => {
  if (!isOpen) return null;

  return (
    <div className="home-popup__overlay" onClick={onClose}>
      <div className="home-popup__content" onClick={(e) => e.stopPropagation()}>
        <button className="home-popup__close" onClick={onClose}>X</button>
        {content}
      </div>
    </div>
  );
};

export default HomePopup;
